module.exports = __webpack_public_path__ + "static/media/appstore-azul.2750356f.svg";